export interface SessionTokenClaims
{
    exp?: number;
    session_state?: string;
    [ key: string ]: unknown;
}

export interface SessionTokenContext
{
    claims: SessionTokenClaims;
    tokenKey: string;
    sessionId: string;
}

export interface SessionMaterials
{
    tokenKey: string;
    key: CryptoKey;
    counter: ArrayBuffer;
}

export interface KeySetRequest
{
    public_key: string;
}

export interface KeySetResponse
{
    public_key: string;
    /** Present when the client explicitly selects the migrated session transport contract. */
    transport_context_version?: string;
}

export const TRANSPORT_CONTRACT_HEADER = 'x-r2-transport-contract';
export const TRANSPORT_CONTEXT_HEADER = 'x-r2-transport-context';
export const TRANSPORT_CONTRACT_VERSION = '1';

export interface SecureEnvelope
{
    data: string;
}

export interface SecureRequestOptions
{
    retryAttempted?: boolean;
    headers?: Record<string, string>;
    /** Called once the feature request enters HTTP dispatch, after session and key preparation. */
    onDispatch?: () => void;
}

export interface EcdhKeyPair
{
    privateKey: CryptoKey;
    publicKey: CryptoKey;
}
